import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Answer, CommentCreate } from '@wdx/clmi/clmi-swagger-gen';
import { REJECT_ANSWERS } from '@wdx/clmi/utils/constants';
import { map } from 'rxjs/operators';
import { DialogComponentOptionsData } from '../../../../models/dialog.model';
import { AnswersFacadeService } from '../../../../state/answers/answers-facade/answers-facade.service';
import { CommentsFacade } from '../shared/services/comments.facade';

@Component({
    selector: 'clmi-comment-dialog',
    templateUrl: './comment-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CommentDialogComponent {
    private commentsFacade = inject(CommentsFacade);
    private answersFacade = inject(AnswersFacadeService);
    private activeModal = inject(NgbActiveModal);

    @Input() data: DialogComponentOptionsData;
    public rejectionReasons$ = this.answersFacade
        .getAnswer$(REJECT_ANSWERS)
        .pipe(
            map((reasons: Answer[]) =>
                reasons
                    .filter(({ isActive }) => isActive)
                    .map(({ name }) => ({
                        label: name,
                        value: name,
                    })),
            ),
        );
    public commentCreate: CommentCreate;
    public commentForm: FormGroup<{
        reason: FormControl<string>;
    }>;

    constructor() {
        this.commentForm = new FormGroup({
            reason: new FormControl(null as string, Validators.required),
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }

    confirm() {
        if (!this.commentCreate || !this.commentForm.valid) {
            return;
        }
        const { mode, entityId, entityType } = this.data;
        const commentCreate = {
            ...this.commentCreate,
            reportIssue: true,
            content: `${this.commentCreate.content} [${this.commentForm.controls.reason.value}]`,
        };
        this.commentsFacade.dispatchCommentData(commentCreate, {
            mode,
            entityId,
            entityType,
        });
        this.activeModal.close();
    }

    commentUpdated(commentCreate: CommentCreate) {
        this.commentCreate = commentCreate;
    }
}
